import {takeLatest, call, all, select} from 'redux-saga/effects';
import configSelector from '../config/selector';

// SERVERS
import Types from './types';
import GlobalTypes from '../globalTypes';

import {fetchWinlosesAsync} from './states/winloses/saga';
import {fetchResumeAsync} from './states/resume/saga';
import {fetchRankAsync} from './states/rank/saga';

function* fetchStartAsync() {
    const config = yield select(configSelector);
    yield call(fetchWinlosesAsync, config.date);
    yield call(fetchResumeAsync, config.date);
    yield call(fetchRankAsync, config.date);
}

function* fetchStart() {
    yield takeLatest(Types.FETCH_START, fetchStartAsync);
    yield takeLatest(GlobalTypes.DATE_DID_CHANGE, fetchStartAsync);
}

export default function* sagas() {
    yield all([
        call(fetchStart),
    ]);
}